import { apiSlice } from "./http";
import { Tags } from "@/enum/tags";
import {
  IConciliationStatusGridResponse,
  IConciliationStatusGridParams,
} from "src/@types/conciliation-status-grid";

export interface IExportStatusGridParams {
  startDate: string;
  endDate: string;
  storeCode?: string;
  regionalId?: string;
  responsibleId?: string;
}

export const conciliationStatusGridApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getConciliationStatusGrid: builder.query<
      IConciliationStatusGridResponse,
      IConciliationStatusGridParams
    >({
      query: ({ startDate, endDate, storeCode, regionalId, responsibleId, status, page, perPage }) => {
        const params = new URLSearchParams({
          startDate,
          endDate,
          ...(storeCode && { storeCode }),
          ...(regionalId && { regionalId }),
          ...(responsibleId && { responsibleId }),
          ...(status && { status }),
          ...(page && { page: String(page) }),
          ...(perPage && { perPage: String(perPage) }),
        });

        return {
          url: `/conciliation-report/status-grid?${params.toString()}`,
          method: "GET",
        };
      },
      providesTags: [Tags.CONCILIATION_STATUS_GRID],
    }),
    exportStatusGridExcel: builder.mutation<string, IExportStatusGridParams>({
      query: ({ startDate, endDate, storeCode, regionalId, responsibleId }) => {
        const params = new URLSearchParams({ startDate, endDate });
        if (storeCode) params.append("storeCode", storeCode);
        if (regionalId) params.append("regionalId", regionalId);
        if (responsibleId) params.append("responsibleId", responsibleId);

        return {
          url: `/conciliation-report/status-grid/export/excel?${params.toString()}`,
          method: "GET",
          responseHandler: async (response: Response): Promise<string> => {
            if (!response.ok) {
              throw new Error(`HTTP error! status: ${response.status}`);
            }
            const jsonResponse = await response.json();
            return jsonResponse.excelFile;
          },
        };
      },
    }),
    exportStatusGridPdf: builder.mutation<string, IExportStatusGridParams>({
      query: ({ startDate, endDate, storeCode, regionalId, responsibleId }) => {
        const params = new URLSearchParams({ startDate, endDate });
        if (storeCode) params.append("storeCode", storeCode);
        if (regionalId) params.append("regionalId", regionalId);
        if (responsibleId) params.append("responsibleId", responsibleId);

        return {
          url: `/conciliation-report/status-grid/export/pdf?${params.toString()}`,
          method: "GET",
          responseHandler: async (response: Response): Promise<string> => {
            if (!response.ok) {
              throw new Error(`HTTP error! status: ${response.status}`);
            }
            const jsonResponse = await response.json();
            return jsonResponse.pdfFile;
          },
        };
      },
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetConciliationStatusGridQuery,
  useExportStatusGridExcelMutation,
  useExportStatusGridPdfMutation,
} = conciliationStatusGridApi;
